import { ServerApiMapper } from '~commonInfra/utils/ServerModelHelper';

import { WebClientListResourceFetcher } from '../../httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import { IListResource } from '../../httpClient/resources/Resource';
import { ResourceQuery } from '../../httpClient/resources/ResourceQuery';
import { IAccelerationRecommendationInfo } from '../models/IAccelerationRecommendationInfo';
import { GetAccelerationRecommendationsRequest } from '../serverApi/requests/GetAccelerationRecommendationsRequest';

class AccelerationRecommendationsResource implements IListResource<IAccelerationRecommendationInfo> {

  private listFetcher = new WebClientListResourceFetcher(GetAccelerationRecommendationsRequest, ServerApiMapper.accelerationRecommendations);

  public all(): ResourceQuery<IAccelerationRecommendationInfo> {
    return new ResourceQuery(this.listFetcher);
  }
}

export const AccelerationRecommendations = new AccelerationRecommendationsResource();